import { FC, useContext, useEffect, useRef } from "react";

import { ConfigProvider, theme } from "antd";
import { useState } from "react";
import { CustomHeader, MainContent } from "layout";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useWindowSize } from "../../hooks/useWindowSize";
import { usePrivy } from "@privy-io/react-auth";
import { REACT_APP_ENV } from "env";
import PrinxContext from "contexts/prinxDataContext";

const Layout: FC = () => {
  const navigate = useNavigate();
  const { defaultAlgorithm, darkAlgorithm } = theme;
  const [isDarkMode, setIsDarkMode] = useState(false);
  const location = useLocation();
  const { isMobile, isTablet } = useWindowSize();
  const { geo } = useContext(PrinxContext);
  const currentPath = location.pathname;
  const isAlphaEnv = REACT_APP_ENV === "ALPHA";
  const [showUSBanner, setShowUSBanner] = useState(false);
  const { authenticated, ready } = usePrivy();

  const APP_AUTH_ROUTES = ["/trade", "/settings"];
  const prevPathRef = useRef(location.pathname);
  useEffect(() => {
    const prevPath = prevPathRef.current;
    if (location.pathname !== prevPath) {
      const privyModal = document.getElementById("headlessui-portal-root") as HTMLDialogElement | null;
      if (privyModal) {
        privyModal.remove();
      }
      prevPathRef.current = location.pathname; // <-- UPDATE THIS!
    }
    if (
      currentPath !== "/" &&
      currentPath !== "/about" &&
      currentPath !== "/waitlist" &&
      currentPath !== "/hiring" &&
      REACT_APP_ENV == "ALPHA"
    ) {
      navigate("/waitlist");
      // console.log("Running Geo Check In Header for Banner", geo, currentPath);
      if (geo?.country == "US") setShowUSBanner(true);
    } else {
      setShowUSBanner(false);
    }
    if (ready && APP_AUTH_ROUTES.includes(currentPath) && !authenticated) {
      navigate("/profile");
    }
  }, [geo, location.pathname, authenticated, ready]);

  return (
    <ConfigProvider
      theme={{
        algorithm: isDarkMode ? darkAlgorithm : defaultAlgorithm
      }}
    >
      {/* Only render CustomHeader if not in ALPHA environment */}
      {/* {!isAlphaEnv && currentPath !== "/" && currentPath !== "/about" && currentPath !== "/waitlist" && (
        <CustomHeader isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode} />
      )} */}

      <MainContent>
        <div className="w-full">
          {showUSBanner && (
            <div className=" bg-yellow-100 border-b-4 border-yellow-500 text-yellow-800 px-4 py-3 flex items-center justify-between z-50">
              <span>You are using Prinx from the United States which is not currently supported.</span>
              <button
                onClick={() => setShowUSBanner(false)}
                className="ml-4 text-yellow-800 hover:text-yellow-900 focus:outline-none"
                aria-label="Close warning"
              >
                ✕
              </button>
            </div>
          )}
          <Outlet />
        </div>
      </MainContent>
    </ConfigProvider>
  );
};

export default Layout;
